import ReadOnlyFilterPanel from "./ReadOnlyFilterPanel";
import { ReadOnlyFilterPanelProps } from "./types";

export default ReadOnlyFilterPanel
export type { ReadOnlyFilterPanelProps };